import AdminAddPasein from "../../components/ListPosCheckPoint/PrintOutQrCode";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPasein/>
    </div>
  );
}
